import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import DigitalDonationReceiptApi from '../generated/api/DigitalDonationReceipt';

export default (service: Servicelayer) => ({
  ...DigitalDonationReceiptApi(service),

  // Add custom calls here

});
